<template>
  <modal class="overflow-hidden">
    <modal-inner :fullscreen="false">
      <div
        class="pop-up-box-title flex justify-center flex-shrink-0 align-middle text-contrast-light content-center text-center"
      >
        <h2
          class="flex-grow text-chplus-title-tutorial font-bold uppercase self-center px-8"
        >
          {{ $t("views.home.election_year") }}
        </h2>
        <div class="relative">
          <button @click="$emit('close')" class="absolute top-0 right-0">
            <icon-close class="text-3xl" />
          </button>
        </div>
      </div>
      <p>{{ $t("views.home.election_year_description") }}</p>
      <div
        class="flex-grow overflow-y-auto flex flex-col justify-center"
        style="margin: 0 -1.232rem; padding: 1.5rem 1.232rem 0 1.232rem"
      >
        <button
          v-for="(year, i) in years"
          :key="year"
          @click="selectedYear = year"
          class="w-full relative overflow-visible border-interaction-light border-2 font-bold rounded-lg py-3 my-1"
          :class="{
            'bg-interaction-light': year === selectedYear,
            'text-interaction-dark': year !== selectedYear
          }"
        >
          <icon-notification
            class="icon-notification"
            v-if="showNotification && i === 0"
          />
          <span>{{ year }}</span>
        </button>
      </div>

      <div
        class="bottom text-chplus-regular flex flex-col justify-center select-none"
      >
        <navigate-small-button
          class="bg-contrast-light"
          style="min-width: 10em;"
          @click="$emit('accept', selectedYear)"
        >
          {{ $t("views.home.validate") }}
        </navigate-small-button>
      </div>
    </modal-inner>
  </modal>
</template>

<script>
import IconClose from "@/components/icons/IconCircleReject";
import Modal from "@/components/layouts/Modal";
import ModalInner from "@/components/layouts/ModalInner";
import NavigateSmallButton from "@/components/buttons/NavigateSmallButton";
import IconNotification from "@/components/icons/IconNotification";

export default {
  name: "YearSelectorModal",
  components: {
    NavigateSmallButton,
    ModalInner,
    Modal,
    IconClose,
    IconNotification
  },
  data: () => ({
    selectedYear: 0
  }),
  created() {
    this.selectedYear = this.selected;
  },
  props: {
    years: {
      type: Array
    },
    selected: {
      type: Number
    },
    showNotification: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selected(newValue) {
      this.selectedYear = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.pop-up-box-title {
  min-height: 4.312rem;
}

.bottom {
  min-height: 6.552rem;
}

@media (min-width: 768px) {
  .bottom {
    min-height: 7.68rem;
  }
}

@media (min-height: 1024px) {
  .pop-up-box-title {
    min-height: 5.12rem;
  }
}

.icon-notification {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(25%, -25%);
}
</style>
